export default __webpack_public_path__ + "static/media/boClick.01c42e5a.png";